module.exports = __webpack_public_path__ + "static/img/success15.048256ea.png";